import styles from './Index.module.scss'
import Content from '../../components/Content'
import Layout from '../../components/Layout'
const VaccinationDashboard = () => {
  return (
    <Layout>
      <Content>
        <div className={styles.base}>
          <div className={styles.body}>
           <div>Vaccination Dashboard <span style={{color:'#e40046'}}>&nbsp; <b>(Proof of concept)</b></span></div>
          </div>
        </div>
      </Content>
    </Layout>
  )
}

export default VaccinationDashboard